import React from 'react';
import { StyleSheet } from 'react-native';
import Icon from '../Icon/Icon';
import { useNavigation } from '@react-navigation/native';

type Props = {};

const MenuIcon = (props: Props) => {
  const navigation = useNavigation();

  return (
    <Icon
      name="menu"
      // @ts-ignore
      onPress={() => navigation.toggleDrawer()}
      style={styles.container}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    marginLeft: 20,
  },
});

export default MenuIcon;
